

























import { Component, mixins, Prop } from 'nuxt-property-decorator'
import { IProductDocumentsItem } from '~/assets/interfaces/products'
import MixinGeneral from '~/assets/mixins/general'
import { extensions } from '~/assets/images/ext/extensions'
import { filterByteToSize } from '~/assets/filters/files'
import ComponentImage from '~/components/images/image.vue'

@Component({
  components: {
    ComponentImage,
  },
  filters: {
    filterByteToSize,
  },
})
export default class ComponentProductDocuments extends mixins(MixinGeneral) {
  @Prop({ type: Array, default: [] }) private items!: IProductDocumentsItem[]

  // Расширение может не прийти (ссылка на страницу, а не на файл) — тогда
  // пробуем достать его из url, иначе показываем иконку ссылки.
  private imagePath(item: IProductDocumentsItem) {
    const ext = (
      item.extension || this.extensionFromUrl(item.url)
    ).toLowerCase()
    return extensions[ext] ? extensions[ext] : extensions.link
  }

  private extensionFromUrl(url: string) {
    const match = /\.([a-z0-9]{2,5})(?:[?#]|$)/i.exec(url || '')
    return match ? match[1] : ''
  }
}
